import { useEffect, useState } from 'react';
import { QueryStatus } from 'src/types';
import { HttpLCTC } from '../api/httpLCTC';
import {OperacionLCTCCuentaHistoriaDTO, OperacionLCTCCuentaVista} from '../types/dto';

export const useLCTCCuentas = (idOperacion: number) => {
    const [cuentas, setCuentas] = useState<OperacionLCTCCuentaVista[]>([]);
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle);

    const fetch = () => {
        if (!idOperacion) return;

        setStatus(QueryStatus.Loading);

        HttpLCTC.getCuentas(idOperacion)
            .then(data => {
                setCuentas(data);
                setStatus(QueryStatus.Success);
            })
            .catch(error => {
                setStatus(QueryStatus.Error);
                console.error(error);
            });
    };

    const refetch = () => fetch();

    useEffect(() => {
        fetch();
    }, [idOperacion]);

    return { cuentas, refetch, status };
};


export const useLCTCCuentasHistoria = (idOperacion: number) => {
    const [historia, setHistoria] = useState<OperacionLCTCCuentaHistoriaDTO[]>([]);
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle);

    const fetch = () => {
        if (!idOperacion) return;

        setStatus(QueryStatus.Loading);

        HttpLCTC.getCuentasHistoria(idOperacion)
            .then(data => {
                setHistoria(data);
                setStatus(QueryStatus.Success);
            })
            .catch(error => {
                setStatus(QueryStatus.Error);
                console.error(error);
            });
    };

    const refetch = () => fetch();

    useEffect(() => {
        fetch();
    }, [idOperacion]);

    return { historia, refetch, status };
};
